import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createMaterialTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: brand.primary },
      secondary: { main: brand.secondary },
      warning: { main: brand.accent },
      background: { default: brand.background, paper: "#ffffff" },
      text: { primary: brand.text, secondary: "rgba(11, 31, 39, 0.72)" }
    },
    shape: { borderRadius: brand.radius },
    typography: {
      fontFamily: brand.fontFamily,
      h1: { fontWeight: 700, letterSpacing: "-0.02em", fontSize: "clamp(2.4rem, 4vw, 3.4rem)" },
      h2: { fontWeight: 700, letterSpacing: "-0.015em", fontSize: "clamp(1.8rem, 3vw, 2.4rem)" },
      h3: { fontWeight: 700, fontSize: "clamp(1.4rem, 2.2vw, 1.9rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.6 },
      body2: { fontSize: "0.95rem", lineHeight: 1.6 },
      button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
    },
    components: {
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: brand.radius, padding: "10px 20px" }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 4, boxShadow: "0 16px 40px rgba(13, 54, 64, 0.08)" }
        }
      },
      MuiLink: {
        styleOverrides: { root: { textDecoration: "none", fontWeight: 500 } }
      }
    }
  });
